import { createApi } from '@reduxjs/toolkit/query/react';

import {
  CreateTransactionBody,
  MIT,
  MITDetailedResponse,
  GetAllMITsQuery,
  RefundMITBody,
  RefundMITResponse,
} from './types';
import { PaginatedResponse } from '../paylink/types';
import { fetchBaseQueryWithAuth } from '../../fetchBaseQuery';
import { runtimeConfig } from '../../../config/runtimeConfig';

export const mitApi = createApi({
  reducerPath: 'mitApi',
  tagTypes: ['MIT'],
  baseQuery: fetchBaseQueryWithAuth(`${runtimeConfig.paylinkApiBaseUrl || ''}/mits`),
  endpoints: (builder) => ({
    getMIT: builder.query<MITDetailedResponse, { mitId: string }>({
      query: ({ mitId }) => `/${mitId}`,
      providesTags: (_result, _error, { mitId }) => [{ type: 'MIT', id: mitId }], // cache mit by mitId
    }),
    getAllMITs: builder.query<PaginatedResponse<MIT>, GetAllMITsQuery>({
      query: (params) => ({
        url: '/',
        method: 'GET',
        params,
      }),
      providesTags: ['MIT'],
    }),
    createTransaction: builder.mutation<MIT, CreateTransactionBody & { merchantId: string }>({
      query: ({ merchantId, ...body }) => ({
        url: '/',
        method: 'POST',
        body,
        params: { merchantId },
      }),
      invalidatesTags: ['MIT'],
    }),
    refundMIT: builder.mutation<RefundMITResponse, RefundMITBody>({
      query: ({ mitId, amount }) => ({
        url: `/${mitId}/refund`,
        method: 'POST',
        body: { amount },
      }),
      invalidatesTags: ['MIT'],
    }),
  }),
});

export const {
  useGetMITQuery,
  useGetAllMITsQuery,
  useCreateTransactionMutation,
  useRefundMITMutation,
} = mitApi;
